<app-dialog-header headerText="{{data.title || 'Confirm'}}" (onCloseClick)="onCancel()" ></app-dialog-header>
<mat-dialog-content class="confirm-message">{{ data.message || 'Are you sure?' }}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button #confirmButton mat-raised-button color="primary" (click)="onConfirm()"
    *ngIf="data.confirmButton !== null">{{data.confirmButton || "OK"}}</button>
    <button #cancelButton mat-button (click)="onCancel()"
    *ngIf="data.cancelButton !== null">{{data.cancelButton || "Cancel"}}</button>
</mat-dialog-actions>